import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('APPLICATIONS_PAGE.APPLICATION_NAME_KEY'),
    stateKey: 'name',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: i18n.t('URL'),
    stateKey: 'url',
    validateOnChange: true,
  },
];

export default fields;
